import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Button, DropBox, FormHeader } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { getLanguage } from "../../utils/environment";
import { useDispatch, useSelector } from "react-redux";
import {
  openConnectDBModal,
  setDBTypeValue,
  setSelectDB,
} from "./redux/actions";
import WarehouseDashboard from "./warehouseDashboard";
import { getConnections } from "./services/dataWarehouse.service";

const lan = getLanguage();

const DataWareHouse = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [formData, setFormData] = useState({
    database: {
      key: "database",
      label: "",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const { dbTypes } = useSelector(({ warehouseReducer }) => warehouseReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    if (dbTypes?.length > 0) {
      setIsConnected(true);
      console.log("Database types available:", dbTypes);

      const updateForm = { ...formData };
      updateForm["database"].elementConfig.options = dbTypes;
      setFormData(updateForm);
    }
  }, [dbTypes]);

  useEffect(() => {
    const checkConnection = async () => {
      setIsLoading(true);
      try {
        const response = await getConnections();
        console.log("Connection response:", response);
        if (response?.data?.status) {
          setIsConnected(true);
          let dbOptions = response.data.env_files || [];
          dbOptions = dbOptions.map((db, id) => ({
            value: db,
            displayValue: db?.split("_")?.[0],
            key: id,
          }));
          console.log("Database options:", dbOptions);
          let isExist = false;
          if (dbTypes?.length > 0) {
            dbOptions.forEach((element) => {
              if (dbTypes.some((dbType) => dbType.value === element.value)) {
                isExist = true;
              }
            });
          }
          if (!isExist) {
            dbOptions.forEach((element) => {
              dispatch(setDBTypeValue(element));
            });
          }
        } else {
          setIsConnected(false);
        }
      } catch (error) {
        console.error("Error fetching database types:", error);
        setIsConnected(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkConnection();
  }, []);

  const updateForm = { ...formData };

  return (
    <>
      <div className="hne-jb-category-wrapper">
        <div className="col-12 jb-category-body-wrapper">
          <div className="wbw_wb-header">
            <FormHeader
              data={{
                formHeader: "Data warehouse",
                size: "md-md",
              }}
            />
            {isConnected && (
              <div className="d-flex">
                <Button
                  data={{
                    mainLayerStyles: "",
                    btnName: "Connect DB",
                    buttonType: "primary",
                    buttonSize: "xs",
                    disable: false,
                  }}
                  onClick={async (e) => {
                    e.preventDefault();
                    dispatch(openConnectDBModal());
                  }}
                />
                <div style={{ minWidth: "205px", marginLeft: "10px" }}>
                  <DropBox
                    data={updateForm.database}
                    onChange={(e) => {
                      const updateForm = { ...formData };
                      updateForm["database"].value = e;
                      setFormData(updateForm);
                      dispatch(setSelectDB(e));
                    }}
                  />
                </div>
              </div>
            )}
          </div>
          {isConnected ? (
            <>
              <WarehouseDashboard />
            </>
          ) : (
            <div className="wbw_welcome-body">
              <div className="wbw_wb-welcome-message">
                Welcome to Data Management Tool
              </div>
              <>
                <Button
                  data={{
                    mainLayerStyles: "",
                    btnName: "Connect DB",
                    buttonType: "primary",
                    buttonSize: "lg",
                    disable: false,
                  }}
                  onClick={async (e) => {
                    e.preventDefault();
                    dispatch(openConnectDBModal());
                  }}
                />
              </>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default withRouter(DataWareHouse);
